import { Component } from '@theme/component';

/** Header disclosures enhance native details; links remain usable without JavaScript. */
class KrNavigation extends Component {
  #controller;
  #observer;

  connectedCallback() {
    super.connectedCallback();
    this.#bind();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#bind();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#observer?.disconnect();
    this.closest('#header-group')?.classList.remove('kr-nav-sticky');
    super.disconnectedCallback();
  }

  #bind() {
    this.#controller?.abort();
    this.#observer?.disconnect();
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    this.closest('#header-group')?.classList.toggle('kr-nav-sticky', this.dataset.sticky === 'true');
    this.addEventListener('toggle', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLDetailsElement) || !target.open || !target.classList.contains('kr-nav__disclosure')) return;
      for (const other of this.querySelectorAll('.kr-nav__disclosure[open]')) {
        if (other !== target) other.removeAttribute('open');
      }
    }, { ...options, capture: true });
    document.addEventListener('click', (event) => {
      if (event.target instanceof Node && !this.contains(event.target)) this.#close();
    }, options);
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const target = event.target instanceof Element ? event.target.closest('details[open]') : null;
      if (target instanceof HTMLDetailsElement) {
        target.open = false;
        target.querySelector('summary')?.focus();
        event.preventDefault();
      } else this.#close();
    }, options);
    document.addEventListener('shopify:block:select', (event) => {
      if (!(event.target instanceof Element) || !this.contains(event.target)) return;
      const disclosure = event.target.closest('details');
      if (disclosure instanceof HTMLDetailsElement) disclosure.open = true;
    }, options);
    this.#observer = new ResizeObserver(() => {
      const group = this.closest('#header-group');
      document.body.style.setProperty('--header-height', `${this.offsetHeight}px`);
      document.body.style.setProperty('--header-group-height', `${group?.getBoundingClientRect().height ?? this.offsetHeight}px`);
    });
    this.#observer.observe(this);
  }

  #close() {
    for (const disclosure of this.querySelectorAll('details[open]')) disclosure.removeAttribute('open');
  }

  /** @param {MouseEvent} event */
  openSearch(event) {
    const modal = document.getElementById('search-modal');
    if (typeof modal?.showDialog !== 'function') return;
    event.preventDefault();
    modal.showDialog();
  }

  /** @param {MouseEvent} event */
  openCart(event) {
    const drawer = document.getElementById('cart-drawer');
    if (typeof drawer?.toggle !== 'function') return;
    event.preventDefault();
    drawer.toggle();
  }
}

if (!customElements.get('kr-navigation')) customElements.define('kr-navigation', KrNavigation);
